import { FC } from 'react';

import { IconProps } from '../types';

export const YoutubeIcon: FC<IconProps> = ({
	size,
	height = 13,
	width = 18,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 13"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M9 0c1.576 0 3.607.07 5.393.21 2.066.175 3.117.525 3.397 2.592.14.945.21 2.24.21 3.572 0 1.33-.07 2.661-.21 3.572-.28 2.1-1.33 2.416-3.397 2.591-1.786.175-3.817.21-5.393.21-1.576 0-3.642-.035-5.393-.21-2.066-.175-3.152-.49-3.432-2.591C.07 9.036 0 7.704 0 6.374c0-1.331.07-2.627.175-3.572C.455.735 1.541.385 3.607.21 5.358.07 7.424 0 9 0ZM7.179 3.677v5.428l4.693-2.731-4.693-2.697Z"
		/>
	</svg>
);
